import React from "react";

import animationData from "./l0EEr8GChs.json";

import Lottie from "lottie-react";

const Animation = () => {
  const isMobile = window.innerWidth <= 768;

  return (
    <Lottie
      animationData={animationData}
      loop={true}
      autoplay={true}
      style={{
        height: isMobile ? 150 : 300,
        width: isMobile ? 180 : 360,
      }}
    />
  );
};

export default Animation;
